import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '../EnvironmentService';
import {FeedbackAllowRequestDto} from './api-types/FeedbackAllowRequestDto';
import {Observable} from 'rxjs';
import {CreateFeedbackRequestDto} from './api-types/CreateFeedbackRequestDto';
import {Quiz} from '../../components/question-preview/types/quiz';
import {BotIdService} from '../BotIdService';

@Injectable({
    providedIn: 'root'
})
export class FeedbackRessource {

    constructor(private http: HttpClient, private environmentService: EnvironmentService, private botIdService: BotIdService) {
    }

    public isFeedbackAllow(msteamsId: string, feedbackAllowRequestDto: FeedbackAllowRequestDto): Observable<string> {
        return this.http.post(`${this.environmentService.environment.serverUrl}/api/profile/feedback/allowed?msteamsid=${msteamsId}`, feedbackAllowRequestDto, {responseType: 'text'});
    }

    public sendFeedback(msteamsId: string, createFeedbackRequestDto: CreateFeedbackRequestDto): Observable<string> {
        return this.http.post(`${this.environmentService.environment.serverUrl}/api/profile/feedback?msteamsid=${msteamsId}`, createFeedbackRequestDto, {responseType: 'text'});
    }

    public getQuestionPreview(msteamsId: string, learningPackageId: string, questionId: string): Observable<Quiz> {
        return this.http.get<Quiz>(`${this.environmentService.environment.serverUrl}/api/profile/feedback/learningPackage/${learningPackageId}/question/${questionId}?msteamsid=${msteamsId}`);
    }

    public isFeedbackAllowForLearn(feedbackAllowRequestDto: FeedbackAllowRequestDto): Observable<string> {
        return this.http.post(`${this.environmentService.environment.serverUrl}/api/learn/profile/feedback/allowed`, feedbackAllowRequestDto, {responseType: 'text'});
    }

    public sendFeedbackForLearn(createFeedbackRequestDto: CreateFeedbackRequestDto): Observable<string> {
        return this.http.post(`${this.environmentService.environment.serverUrl}/api/learn/profile/feedback`, createFeedbackRequestDto, {
            responseType: 'text',
            params: {channel: this.botIdService.getBotId()}
        });
    }

    public getQuestionPreviewForLearn(learningPackageId: string, questionId: string): Observable<Quiz> {
        return this.http.get<Quiz>(`${this.environmentService.environment.serverUrl}/api/learn/profile/feedback/learningPackage/${learningPackageId}/question/${questionId}`);
    }
}
